export const addOverflowHiddenToBody = () => {
  document.body.classList.add("chrome-hide-overflow");
};

export const removeOverflowHiddenFromBody = () => {
  document.body.classList.remove("chrome-hide-overflow");
};
